var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-tableDelVoip"},[_c('datatable',{staticClass:"tableDelVoip",attrs:{"title":"","columns":_vm.tableColumnsDelVoip,"rows":_vm.tableRowsDelVoip,"sortable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }